var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4909",
    "data-name": "Group 4909",
    transform: "translate(-177 -752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4768",
    "data-name": "Group 4768",
    transform: "translate(-1 -7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4364",
    "data-name": "Rectangle 4364",
    width: 24,
    height: 24,
    transform: "translate(178 759)",
    fill: "none",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767",
    transform: "translate(183 762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6696",
    "data-name": "Path 6696",
    d: "M13.16,7.759a5.356,5.356,0,0,1-3.41-1.31,4.657,4.657,0,0,1-1.12-2.07c0-.35.02-.72.05-1.1a.34.34,0,0,0-.01-.1,1,1,0,0,0-.21.2,8.819,8.819,0,0,0-.83.89,15.609,15.609,0,0,0-2.34,4.28,4.4,4.4,0,0,0-.73-.06c-.1,0-.21,0-.31.01,1.64-4.43,3.64-6.67,7.47-8.45a.49.49,0,0,1,.66.24.5.5,0,0,1-.24.67,13.538,13.538,0,0,0-3.34,2.1,5.193,5.193,0,0,1,3.05,1.29,5.438,5.438,0,0,1,1.31,3.41",
    fill: "rgba(151,161,194,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M13.75,12.789A3.666,3.666,0,0,1,10.2,16.3h-.06a3.519,3.519,0,0,1-1.91-.55A4.541,4.541,0,0,0,7.85,9.9a3.337,3.337,0,0,1,1.08-.62,7.889,7.889,0,0,1-1.3-5.01,8.819,8.819,0,0,1,.83-.89,1,1,0,0,1,.21-.2.34.34,0,0,1,.01.1c-.03.38-.05.75-.05,1.1-.01,2.17.46,3.72,1.44,4.69h.07a3.546,3.546,0,0,1,2.58,1.1,3.589,3.589,0,0,1,1.03,2.62",
    fill: "rgba(151,161,194,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6698",
    "data-name": "Path 6698",
    d: "M9.12,13.049a4.573,4.573,0,0,1-.89,2.7.01.01,0,0,0-.01.01,4.524,4.524,0,0,1-3.66,1.85A4.56,4.56,0,0,1,4.25,8.5c.1-.01.21-.01.31-.01a4.4,4.4,0,0,1,.73.06,4.565,4.565,0,0,1,2.55,1.34l.01.01a4.57,4.57,0,0,1,1.27,3.15",
    fill: "#97a1c2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/casino.2d63f49510aa376529ab9dcae512418a.svg";
export { ForwardRef as ReactComponent };